import React, { useState } from 'react';
import Face2FaceService from '../../../helpers/utils/formatTimeToMin';

const F2FPackages = (props) => {
  const [isSelected, setIsSelected] = useState(false);
  const packageName = props?.packageDetail?.name?.toUpperCase();

  const handleButtonClick = (id, us_id, pck_ty) => {
    setIsSelected(!isSelected);
    props.setPackage_id(id);
    props.setReceive(us_id);
    props.setPck_type(pck_ty);
  };

  return (
    <>
      <div
        className={`f2f-package-select-box ${
          props.packagid == props?.packageDetail?.id ? 'selected' : ''
        }`}
        style={{ cursor: 'pointer' }}
        onClick={() =>
          handleButtonClick(props?.packageDetail?.id, props?.packageDetail?.user_id, packageName)
        }
      >
        <div className='f2f-package-des f2f-package-name'>
          <span className='f2f-package-des-name'>{packageName}</span>
        </div>
        <div className='f2f-package-des margin-package-exten-des-5'>
          <span
            className={`f2f-package-des-price ${
              props.packagid == props?.packageDetail?.id ? 'selected-price' : 'delected-price'
            } `}
          >
            $
            {(
              Number(props?.packageDetail?.final_price) /
              Face2FaceService.formatTimeToMinutes(props?.packageDetail?.time || '00:00:00')
            ).toFixed(2)}
          </span>
        </div>
        <div className='f2f-package-des margin-package-exten-des-5'>
          <span className='f2f-package-des-limit'>PER MINUTE</span>
        </div>
        <div className='duration'>
          DURATION :{' '}
          <span className='package-duration'>{`${Face2FaceService.formatTimeToMinutes(
            props?.packageDetail?.time,
          )}`}</span>{' '}
          MIN
        </div>
      </div>
    </>
  );
};

export default F2FPackages;
